module.exports = __webpack_public_path__ + "static/boardmember-min-c26e72b039bd4e132611dd5bc7735ae4.jpg";